module.exports = __webpack_public_path__ + "media/bg/notification_bg-455728ef.jpg";